import { InitializeCompleteRequestSchema, InitializeCompleteResponseSchema } from './initialize-complete.schema';
/**
 * Initialize Complete Contract
 * POST /api/v2/initialize/complete
 * Marks the initial-setup wizard as finished (idempotent).
 */ export const InitializeCompleteContract = {
    method: 'POST',
    path: '/api/v2/initialize/complete',
    description: 'Mark the initial-setup wizard as finished',
    requestSchema: InitializeCompleteRequestSchema,
    responseSchema: InitializeCompleteResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Prerequisites missing - departments and users not initialized; or integrity gate failed (INITIAL_SETUP_INCOMPLETE) - unresolved temp departments or wizard-imported users without a department remain',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-complete.contract.js.map